import { observable, action } from 'mobx'
import { observer } from 'mobx-react'
import sha1 from 'sha1'

import Ds from './ds'

class Users {

  @observable all = []
  @observable resetEmail = []
  @observable passwordReset = []
  @observable resetTokenValidity = []
  @observable details = {
    username: '',
    password: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    phone: '',
    email: '',
    accessLevel: ''
  }

  @observable ds = new Ds()

  @action loadAllUsers(callback) {
    let query = `{ users(status: ${ 1 }, hash: "${ localStorage.getItem('userHash') }") { id username password firstName lastName email accessLevel status } }`

    console.log(query)

    this.ds.query(query, (data) => {
      this.all = data.users

      if (callback) {
        return callback(this.all)
      }
    })
  }

  @action loadUser(id) {
    this.ds.query(`{ users(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id organizationId username firstName lastName address city state zipCode phone email accessLevel } }`, (data) => {
      if (data.users.length > 0) {
        this.details = data.users[0]

        document.getElementById('editUserId').value = data.users[0].id
        document.getElementById('editUsername').value = data.users[0].username
        document.getElementById('editFirstName').value = data.users[0].firstName
        document.getElementById('editLastName').value = data.users[0].lastName
        document.getElementById('editAddress').value = data.users[0].address
        document.getElementById('editCity').value = data.users[0].city
        document.getElementById('editState').value = data.users[0].state
        document.getElementById('editZipCode').value = data.users[0].zipCode
        document.getElementById('editEmail').value = data.users[0].email
        document.getElementById('editPhone').value = data.users[0].phone
        document.getElementById('editAccessLevel').value = data.users[0].accessLevel
      }
    })
  }

  @action loadAllOrganizationUsers(orgId, callback) {
    let query = `{ users( organizationId: ${ orgId }, hash: "${ localStorage.getItem('userHash') }") { id username password firstName lastName email accessLevel }}`
    //console.log(query)
    this.ds.query(query, (data) => {
      this.all = data.users.map((user) => {
        user.name = user.firstName + ' ' + user.lastName

        return user
      })

      if (callback) {
        return callback(this.all)
      }
    })
  }

  @action addUser(user) {
    let query = '';

    query = `mutation {
      addUser(
        organizationId: ${ user.organizationId },
        groupId: ${ user.groupId },
        username: "${ user.username }",
        password: "${ user.password }",
        firstName: "${ user.firstName }",
        lastName: "${ user.lastName }",
        email: "${ user.email }",
        phone: "${ user.phone }",
        address: "${ user.address}",
        city: "${ user.city }",
        state: "${ user.state }",
        zipCode: "${ user.zipCode}",
        accessLevel: ${ user.accessLevel },
        status: ${ user.status },
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
      }
    }`;

    console.log(query);

    this.ds.query(query, (data) => {
      this.loadAllUsers()
    })
  }

  @action updateProfile(profile) {
    let query = ''

    if (profile.password) {
      query = `mutation { updateProfile(
        id: ${ profile.id },
        firstName: "${ profile.firstName }",
        lastName: "${ profile.lastName }",
        email: "${ profile.email }",
        password: "${ sha1(profile.password) }",
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
      }}`
    } else {
      query = `mutation { updateProfile(
        id: ${ profile.id },
        firstName: "${ profile.firstName }",
        lastName: "${ profile.lastName }",
        email: "${ profile.email }",
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
      }}`
    }

    //console.log(query)

    this.ds.query(query, (data) => {
      localStorage.setItem('userFirstName', profile.firstName)
      localStorage.setItem('userLastName', profile.lastName)
      localStorage.setItem('userEmail', profile.email)
    })
  }

  @action updateUser(user) {
    let query = `mutation { updateUser(
      id: ${ user.id },
      organizationId: ${ user.organizationId },
      groupId: ${ user.groupId },
      username: "${ user.username }",
      password: "${ user.password }",
      firstName: "${ user.firstName }",
      lastName: "${ user.lastName }",
      email: "${ user.email }",
      phone: "${ user.phone }",
      address: "${ user.address}",
      city: "${ user.city }",
      state: "${ user.state }",
      zipCode: "${ user.zipCode}",
      accessLevel: ${ user.accessLevel },
      hash: "${ localStorage.getItem('userHash') }"
    ) { id }}`

    console.log(query)

    this.ds.query(query, (data) => {
      this.loadAllUsers()
    })
  }

  @action inactivateUser(id) {
    let query = `mutation { updateUser(
      id: ${ id },
      status: ${ 0 },
      hash: "${ localStorage.getItem('userHash') }"
    ) { id }}`

    console.log(query)

    this.ds.query(query, (data) => {
      this.loadAllUsers()
    })
  }

  @action deleteUser(id) {
    this.ds.query(`mutation { deleteUser(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllUsers()
    })
  }

  @action getUserFromHash(hash, globals) {
    this.ds.query(`{
      userFromHash(hash: "${ hash }") {
        id
        hash
        userId
        user {
          id
          username
          firstName
          lastName
          email
          accessLevel
          organizationId
        }
      }
    }`, (data) => {
      if (data.userFromHash.length > 0) {
        globals.setLoggedInUser(data.userFromHash[0])
      } else {
        globals.logout()
      }
    })
  }

  @action loginWithUsernamePassword(username, password, globals, onFail) {
    let query = `mutation {
      login(
        username: "${ username }",
        password: "${ sha1(password) }",
        status: ${ 1 }
      ) {
        id
        userId
        user {
          username
          firstName
          lastName
          email
          accessLevel
          organizationId
        }
        hash
      }
    }`

    //console.log(query)

    this.ds.query(query, (data) => {
      if (data.login.hash == null || data.login.has == '') {
        onFail()
      } else {
        globals.loggedIn = true
        globals.setLoggedInUser(data.login)
        document.body.className = 'nav-md'
        document.body.style = 'height: 100%; background-color: #2a3f54'

        localStorage.setItem('accessLevel', data.login.user.accessLevel)
        localStorage.setItem('userHash', data.login.hash)
        window.location.reload()
      }
    })
  }

  @action forgotPassword(email, callback) {
    let query = `mutation {
      forgotPassword(
        email: "${ email }",
        status: ${ 1 }
      ) { statusCode data }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      console.log('Data: ', data);
      this.resetEmail = data

      if (callback) {
        return callback(this.resetEmail)
      }
    })
  }

  @action resetPassword(resetToken, password, callback) {
    let query = `mutation {
      resetPassword(
        resetToken: "${ resetToken }",
        password: "${ sha1(password) }",
      ) { statusCode data }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      console.log('Data: ', data);
      this.passwordReset = data

      if (callback) {
        return callback(this.passwordReset)
      }
    })
  }

  @action checkResetToken(resetToken, callback) {
    let query = `mutation {
      checkResetToken(
        resetToken: "${ resetToken }"
      ) { statusCode data }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      console.log('Data: ', data);
      this.resetTokenValidity = data

      if (callback) {
        return callback(this.resetTokenValidity)
      }
    })
  }
}

export default new Users()



// WEBPACK FOOTER //
// ./src/stores/users.js